import React from 'react';

const Preloader = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#020308] overflow-hidden">
      <style>
        {`
          .loader-wrapper { text-align: center; display: flex; flex-direction: column; gap: 18px; font-family: "Orbitron", sans-serif; }
          .title { font-size: 0.8rem; letter-spacing: 0.5em; text-transform: uppercase; color: #9ca3af; }
          .main-text { font-size: 1.2rem; letter-spacing: 0.35em; text-transform: uppercase; color: #f5f5f5; }
          .main-text span.accent { color: #5af0ff; }
          .spinner { width: 60px; height: 60px; margin: 0 auto; border: 2px solid rgba(0, 240, 255, 0.1); border-top-color: #00f0ff; border-radius: 50%; animation: spin 1s linear infinite; }
          @keyframes spin { to { transform: rotate(360deg); } }
        `}
      </style>
      <div className="loader-wrapper">
        <div className="title">ENGINEERED BY MIDNIGHTNEURON</div>
        <div className="spinner"></div>
        <div className="main-text">LOADING <span className="accent">MIDNIGHTNEURON.COM</span></div>
      </div>
    </div>
  );
};

export default Preloader;